<template>
  <div class="bad">
    <div class="sorry">
      <h1>{{ $tr('badBrowser.yourBrowserIsSludge') }}</h1>
      <p>{{ $tr('badBrowser.techonoliges') }}</p>
    </div>

    <div class="what-to-do-container">
      <div class="what-to-do">
        <h1>{{ $tr('badBrowser.whatDoIDo') }}</h1>

        <ul class="steps">
          <li>
            <span class="number">1</span>
            <div class="container">
              <p>{{ $tr('badBrowser.copyLink') }}</p>

              <div class="link">
                <input
                  ref="registrationLink"
                  class="registrationLink"
                  name="registration_link"
                  :value="currentUrl"
                  readonly
                />
                <button
                  v-tooltip.top-center="$tr('vacancy.preferences.settings.copyToClipboard')"
                  class="vcv-button iconed gray right-button"
                  @click="copyLinkToClipboard(currentUrl)"
                >
                  <i class="icon icon-copy"></i>
                  <span>{{ $tr('vacancy.preferences.settings.copy') }}</span>
                </button>
              </div>
            </div>
          </li>

          <li>
            <span class="number">2</span>
            <div class="container">
              <p>{{ $tr('badBrowser.putLink') }}</p>

              <div class="browsers">
                <a class="browser" :href="linkToChrome" target="_blank" rel="noopener">
                  <img src="/static/images/elements/badbrowser/chrome.png" alt="Google Chrome" />
                  <span>Google Chrome</span>
                </a>
                <a class="browser" :href="linkToFirefox" target="_blank" rel="noopener">
                  <img src="/static/images/elements/badbrowser/firefox.png" alt="Firefox" />
                  <span>Firefox</span>
                </a>
                <a
                  v-if="locale === 'ru'"
                  class="browser"
                  href="https://browser.yandex.ru/"
                  target="_blank"
                  rel="noopener"
                >
                  <img src="/static/images/elements/badbrowser/yandex.png" alt="Яндекс.Браузер" />
                  <span>Яндекс.Браузер</span>
                </a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import CopyTextToClipboard from '@/components/mixin/CopyTextToClipboard.js';

  export default {
    name: 'BadBrowser',

    mixins: [CopyTextToClipboard],

    props: {
      locale: {
        type: String,
        required: true
      }
    },

    computed: {
      currentUrl() {
        return window.location.href;
      },

      linkToChrome() {
        const zone = this.locale === 'ru' ? 'ru' : 'com';

        return `https://www.google.${zone}/chrome/index.html`;
      },

      linkToFirefox() {
        return this.locale
          ? `https://www.mozilla.org/${this.locale}/firefox/new/`
          : `https://www.mozilla.org/ru/firefox/new/`;
      }
    },

    methods: {
      copy(arg) {
        this.copyLinkToClipboard(arg);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .bad {
    width: 100%;

    h1,
    p,
    ul,
    li {
      margin: 0;
      padding: 0;
    }

    .sorry {
      text-align: center;
      margin-bottom: 50px;

      h1 {
        font-weight: 500;
        font-size: 28px;
        margin-bottom: 34px;
      }

      p {
        line-height: 22px;
        font-size: 16px;
      }
    }

    .what-to-do-container {
      background: rgba(196, 196, 196, 0.1);
      width: 100%;
    }

    .what-to-do {
      max-width: 560px;
      margin: 0 auto;
      padding: 50px 0 60px;

      h1 {
        font-weight: 500;
        font-size: 22px;
        text-align: center;
      }
    }

    ul.steps {
      margin-top: 44px;

      li {
        list-style: none;
        margin-bottom: 36px;
        display: flex;
        align-items: flex-start;
        width: 100%;

        span.number {
          display: block;
          font-weight: 500;
          font-size: 18px;
          width: 30px;
          height: 26px;
          text-align: center;
          line-height: 26px;
          color: #3eaf29;
          border: 2px solid #3eaf29;
          border-radius: 50%;
          margin-right: 20px;
        }
      }
    }

    .container {
      width: 100%;

      p {
        line-height: 22px;
        font-size: 16px;
        margin-bottom: 8px;
        padding-top: 4px;

        &.center {
          padding-top: 36px;
          text-align: center;
        }
      }

      .browsers {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 52px;

        .browser {
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;

          &:hover {
            color: inherit;
          }

          img {
            width: 74px;
            height: 74px;
            margin-bottom: 6px;
          }
        }
      }
    }

    .link {
      display: flex;

      .registrationLink {
        width: calc(100% - 200px);
        height: 40px;
        padding-top: 8px;
        padding-bottom: 8px;
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      .vcv-button {
        width: 200px;
        margin-left: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
</style>
